import type { PureFunction } from '@bonsai-components/utility-types';
import { semanticColors } from '@moderneinc/design-system-tokens';
import {
  ADMIN_ACCESS_TOKENS_PATH,
  ADMIN_SETTINGS_PATH,
  AUDIT_LOGS_PATH,
  CONNECTORS_PATH,
  ORGANIZATION_SOURCES_PATH,
  USERS_PATH
} from '../../../constants/general';
import { getTenantName } from '../../../helpers/next.helpers';
import {
  AccessTokenIcon,
  AuditLogsIcon,
  ConnectorsIcon,
  OrganizationSourcesIcon,
  ProfilingIcon,
  SettingsIcon,
  UserIcon
} from '../../../icons/icons';
import type { NavItem } from '../left-navigation/left-navigation.component';

/** Matched in the admin menu to gate this item behind the profiling capability. */
export const PROFILING_ADMIN_ITEM_LABEL = 'Profiling';

export const getLeftNavAdminMenuItems: PureFunction<
  void,
  Array<NavItem>
> = () => [
  {
    label: 'Connectors',
    href: CONNECTORS_PATH,
    icon: <ConnectorsIcon color={semanticColors.color.icon.default} />,
    description: 'View connected connectors',
    shortcut: 'G'
  },
  {
    label: 'Organization sources',
    href: ORGANIZATION_SOURCES_PATH,
    icon: <OrganizationSourcesIcon color={semanticColors.color.icon.default} />,
    description: 'View each connector’s organization CSV sources'
  },
  {
    label: 'Audit logs',
    href: AUDIT_LOGS_PATH,
    icon: <AuditLogsIcon color={semanticColors.color.icon.default} />,
    description: 'View audit logs',
    shortcut: 'L'
  },
  {
    label: 'Access tokens',
    href: ADMIN_ACCESS_TOKENS_PATH,
    icon: <AccessTokenIcon color={semanticColors.color.icon.default} />,
    description: 'Users with access tokens',
    shortcut: 'T'
  },
  {
    label: 'Users',
    href: USERS_PATH,
    icon: <UserIcon color={semanticColors.color.icon.default} />,
    description: 'Users of the platform',
    shortcut: 'U'
  },
  {
    label: PROFILING_ADMIN_ITEM_LABEL,
    href: () => `https://profiler.${getTenantName()}.moderne.io`,
    icon: <ProfilingIcon color={semanticColors.color.icon.default} />,
    description: 'Open the continuous profiler',
    external: true
  },
  {
    label: 'Settings',
    href: ADMIN_SETTINGS_PATH,
    icon: <SettingsIcon color={semanticColors.color.icon.default} />,
    description: 'Manage system profiling and platform settings'
  }
];
